import React from 'react';

import { MainWrapper, Icon } from './styles';

import image from '../../assets/illustrations/social_life.svg';

function Main() {
    return (
        <MainWrapper>
            <section>
                <h1>Get more for your money.</h1>
                <p>SEO orem ipsum dolor sit, amet consectetur adipisicing elit. Perspiciatis porro nisi maiores veritatis officia molestiae aut minima eius quod voluptate.</p>

                <h2>
                    <Icon/>
                Google
                <span>Analytics</span>
                </h2>
            </section>

            <figure>
                <img src={image} alt="" />
            </figure>
        </MainWrapper>
    );
}

export default Main;